import type { VektorStore } from '../../lib/use-vektor-store';
import { ModeToggle } from './ModeToggle';
import { PresetsDropdown } from './PresetsDropdown';
import { CoreControls } from './CoreControls';
import { AdvancedGroup } from './AdvancedGroup';
import { PreprocessingGroup } from './PreprocessingGroup';
import { PotraceGroup } from './PotraceGroup';
import { VTracerGroup } from './VTracerGroup';
import { PostprocessGroup } from './PostprocessGroup';
import { OutputGroup } from './OutputGroup';

export function ControlsPanel({ store }: { store: VektorStore }) {
  const { params, histogram, setParam, setMode, resetParams, loadParams } = store;
  return (
    <aside className="flex h-full w-[340px] flex-col gap-3 overflow-y-auto border-l border-[var(--border)] bg-[var(--theme)] p-4">
      <div className="mb-1 flex flex-col gap-2">
        <span className="tech-label">Trace Controls</span>
        <span className="accent-rule" />
      </div>
      <PresetsDropdown params={params} onLoad={loadParams} />
      <ModeToggle mode={params.mode} onChange={setMode} />
      <CoreControls params={params} histogram={histogram} setParam={setParam} />

      <AdvancedGroup title="Preprocessing"><PreprocessingGroup params={params} setParam={setParam} /></AdvancedGroup>
      {params.mode === 'bw' && <AdvancedGroup title="Advanced tracing — Potrace"><PotraceGroup params={params} setParam={setParam} /></AdvancedGroup>}
      {params.mode === 'color' && <AdvancedGroup title="Advanced tracing — VTracer"><VTracerGroup params={params} setParam={setParam} /></AdvancedGroup>}
      <AdvancedGroup title="Post-process"><PostprocessGroup params={params} setParam={setParam} /></AdvancedGroup>
      <AdvancedGroup title="Output"><OutputGroup params={params} setParam={setParam} /></AdvancedGroup>

      <button onClick={resetParams} className="mt-2 self-start text-sm text-[var(--secondary)] underline">Reset all</button>
    </aside>
  );
}
